import TheCategoriesLabels from '~/components/Layout/TheCategoriesLabels.vue';
import { useGetTranslations } from '@/composables/useGetTranslations';
export default defineComponent({
  name: 'CategoriesSisters',
  props: {
    categories: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  components: {
    TheCategoriesLabels: TheCategoriesLabels
  },
  setup: function setup() {
    var _useGetTranslations = useGetTranslations(),
      translate = _useGetTranslations.translate;
    return {
      translate: translate
    };
  }
});